<template>
  <a
    :href="url"
    :class="classActive"
    @click="handleClick"
  >
    <v-badge
      v-if="notifications > 0"
      bordered
      overlap
      :content="notifications"
      color="red"
    >
      <div class="w-100 text-yellow">
        <v-icon color="amber">mdi-bell</v-icon>
        <div class="py-0 my-1 text-lg mt-2">อัพเดต</div>
      </div>
    </v-badge>
    <div
      v-else
      class="w-100 text-yellow"
    >
      <v-icon color="amber">mdi-bell</v-icon>
      <div class="py-0 my-1 text-lg mt-2">อัพเดต</div>
    </div>
  </a>
</template>
<script>
export default {
  name: 'NotificationBell',
  props: {
    url: { type: String, default: '' },
    classActive: { type: String, default: '' },
  },
  computed: {
    notifications() {
      return this.$store.getters['notification/count']();
    },
  },
  methods: {
    async handleClick(e) {
      e.preventDefault();
      await this.$store.commit('notification/ackAll');
      window.location.href = this.url;
    },
  },
};
</script>
